import { usePredefinedCommentsList } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-list/hooks/use-predefined-comments-list.hook';
import { BulkActionsComponent } from 'commons/components';
import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { useActivateDeactivatePredefinedComment } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-list/hooks/use-activate-deactivate-predefined-comment.hook';
import { BulkActivateDeactivatePredefinedCommentComponent } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-bulk-actions/components/bulk-activate-deactivate-predefined-comment.component';
import { useTranslation } from 'core/i18n';
import { BulkEditPredefinedCommentComponent } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-bulk-actions/components/bulk-edit-predefined-comment.component';
import { usePredefinedCommentNavigation } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-list/hooks/use-predefined-comment-navigation.hook';

export const PredefinedCommentsBulkActionsContainer: React.FC = () => {
    const { t } = useTranslation();
    const { selectedRows, setSelectedRows } = usePredefinedCommentsList();
    const { showActivateModal, showDeactivateModal } = useActivateDeactivatePredefinedComment();
    const { navigateToEdit } = usePredefinedCommentNavigation();

    const renderActivateDeactivateActions = () => {
        if (selectedRows.length === 0) {
            return null;
        }
        const allActive = selectedRows.every((row) => row.active);
        const allInactive = selectedRows.every((row) => !row.active);

        if (allInactive) {
            return (
                <BulkActivateDeactivatePredefinedCommentComponent
                    text={t('settings.devices.predefined-comments.list.actions.activate')}
                    iconName="circle_on_off"
                    onClick={() => showActivateModal(selectedRows)}
                />
            );
        }

        if (allActive) {
            return (
                <BulkActivateDeactivatePredefinedCommentComponent
                    text={t('settings.devices.predefined-comments.list.actions.deactivate')}
                    iconName="circle_remove"
                    onClick={() => showDeactivateModal(selectedRows)}
                />
            );
        }
        return null;
    };

    return (
        selectedRows.length > 0 && (
            <BulkActionsComponent
                options={[
                    <PocTypography key="bulk_actions_selected" element="span" variant="subtitle1">
                        {t('settings.devices.predefined-comments.bulk-actions.selected', {
                            amount: selectedRows.length,
                        })}
                    </PocTypography>,
                    <PocButton
                        key="bulk_actions_deselect"
                        variant="tertiary"
                        size="medium"
                        onClick={() => setSelectedRows([])}
                    >
                        {t('settings.devices.predefined-comments.bulk-actions.clear-all')}
                    </PocButton>,
                ]}
            >
                {selectedRows.length === 1 && (
                    <BulkEditPredefinedCommentComponent onClick={() => navigateToEdit(selectedRows[0].id)} />
                )}
                {renderActivateDeactivateActions()}
            </BulkActionsComponent>
        )
    );
};
